export type Match = {
  match: {
    start: number;
    end: number;
    txt: string;
  };
  withContext: {
    start: number;
    end: number;
    txt: string;
  };
  input: string;
};

export const matchText = (
  txt: string,
  query: RegExp,
  contextLength: number // set to 0 to show everything
): Match[] => {
  const matches = Array.from(txt.matchAll(query));
  const matchWindows = matches.map((match) => {
    const matchText = match[0];
    const index = match.index || 0; // should always be defined
    const input = match.input || '';
    if (!contextLength) {
      return {
        match: {
          start: index,
          end: index + matchText.length
        },
        withContext: {
          start: 0,
          end: input.length
        },
        input
      };
    }
    const remainingCharacters = contextLength - matchText.length;
    const remainingOnEachSide = Math.ceil(remainingCharacters / 2);
    let leftMost = index - remainingOnEachSide;
    let rightMost = index + matchText.length + remainingOnEachSide;
    // we can get a little smart here: shift the match to the left or to the right if the pre and post are too short
    if (leftMost < 0) {
      rightMost = rightMost + Math.abs(leftMost);
    }
    if (rightMost >= input.length) {
      leftMost = leftMost - Math.abs(rightMost - input.length);
    }
    leftMost = Math.max(0, leftMost);
    rightMost = Math.min(input.length, rightMost);
    return {
      match: {
        start: index,
        end: index + matchText.length
      },
      withContext: {
        start: leftMost,
        end: rightMost
      },
      input
    };
  });
  // another opportunity to be smarter - if several matches appear and they overlap,
  // we can return a little less information. Or maybe we just leave this to others to deal with
  return matchWindows.map((x) => {
    const matchText = x.input.slice(x.match.start, x.match.end);
    const withContextText = [
      x.withContext.start > 0 ? '…' : '',
      x.input.slice(x.withContext.start, x.withContext.end),
      x.withContext.end < x.input.length ? '…' : ''
    ]
      .join('')
      .replace(query, (m) => {
        return `**${m}**`;
      });
    return {
      ...x,
      match: {
        ...x.match,
        txt: matchText
      },
      withContext: {
        ...x.withContext,
        txt: withContextText
      }
    };
  });
};
